// extracted by mini-css-extract-plugin
export default {"storeHoursMessageContainer":"StoreHoursMessage-module__storeHoursMessageContainer--cX24X"};